import { productDetailsImageCarouselStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.imageCarousel = {
    ...styles.imageCarousel,
    nextArrowButton: {
        ...styles.imageCarousel?.nextArrowButton,
        css: css`
            ${styles.imageCarousel?.nextArrowButton?.css}
            position: relative;
            height: 54px;
            min-height: 54px;
            padding: 0;
            width: 70%;

            ${IconWrapper} {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        `,
    },
    prevArrowButton: {
        ...styles.imageCarousel?.prevArrowButton,

        css: css`
            ${styles.imageCarousel?.prevArrowButton?.css}
            position: relative;
            height: 54px;
            min-height: 54px;
            padding: 0;
            width: 70%;

            ${IconWrapper} {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        `,
    },

    image: {
        css: css`
            ${styles.image?.css}
            border: 0;

            img {
                height: 62px;
                width: 62px;
                aspect-ratio: 1 / 1;
                object-fit: contain;
                padding: 0;
            }
        `,
    },
    selectedImage: {
        css: css`
            ${styles.selectedImage?.css}

            border: 0;
            border: solid 2px ${getColor(colorStrings.primaryMain)};
            border-radius: 4px;

            img {
                height: 62px;
                width: 62px;
                aspect-ratio: 1 / 1;
                object-fit: contain;
                padding: 0;
            }
        `,
    },
    carouselContainer: {
        ...styles.imageCarousel?.carouselContainer,
        css: css`
            ${styles.imageCarousel?.carouselContainer?.css}
            padding: 10px 0;
        `,
    },
    carouselSlideInner: {
        ...styles.imageCarousel?.carouselSlideInner,
        css: css`
            ${styles.imageCarousel?.carouselSlideInner?.css}
            button {
                padding: 0;
                width: auto;
                height: 62px;
                min-width: 62px;

                /* ${mediaQueriesBP.maxSM} {
                    width: 62px !important;
                    height: 62px;
                } */
            }
        `,
    },
};
